<span *ngIf="isSpinning.containsActiveSpinner()">
    <br />
    <span>
      <mat-spinner></mat-spinner>
    </span>
    <span>
      <h4>{{ message }}</h4>
    </span>
  </span>
  <ng-content *ngIf="!isSpinning.containsActiveSpinner()"></ng-content>